/**
 * Was der Import mit einer Zeile vorhat. Bewusst VOR dem Schreiben entschieden und anzeigbar:
 * niemand soll 1192 Datensätze anfassen und danach nachsehen, was passiert ist.
 */
export type ImportAction =
  /** Gibt es noch nicht -- wird angelegt. */
  | 'create'
  /** Nummer existiert schon -- wird überschrieben. */
  | 'update'
  /** Nummer existiert, Daten sind gleich -- nichts zu tun. */
  | 'unchanged'
  /** Wird NICHT importiert. Der Grund steht in den issues. */
  | 'blocked';

export type IssueLevel =
  /** Blockiert die Zeile. */
  | 'error'
  /** Zeile geht durch, aber jemand sollte hinsehen. */
  | 'warning';

export interface ImportIssue {
  readonly level: IssueLevel;
  /** Die Spalte, um die es geht -- damit man in der CSV nachsehen kann. */
  readonly column: string | null;
  readonly message: string;
}

export interface PlannedRow<TDraft> {
  /** Zeilennummer wie in Excel. Zum Nachschlagen, nicht als laufender Index. */
  readonly line: number;
  /** Die fachliche Nummer (K_NUMMER / ERFASS_NR) -- leer, wenn sie fehlt. */
  readonly number: string;
  /** Kurzbezeichnung für die Vorschau. */
  readonly label: string;
  readonly action: ImportAction;
  /** null, wenn blockiert. */
  readonly draft: TDraft | null;
  readonly issues: readonly ImportIssue[];
}

export interface ImportPlan<TDraft> {
  readonly rows: readonly PlannedRow<TDraft>[];
  readonly counts: Readonly<Record<ImportAction, number>>;
  /** Zeilen, die nur aus Trennern bestanden -- gezählt, nicht verschwiegen. */
  readonly blankRowsSkipped: number;
  /** Spalten der Datei, die FORQ nicht verwendet. Ehrlicher als so zu tun, als sei alles drin. */
  readonly unusedColumns: readonly string[];
  /** Spalten, die FORQ braucht, die die Datei aber nicht hat. */
  readonly missingColumns: readonly string[];
}

export function countActions<TDraft>(rows: readonly PlannedRow<TDraft>[]): Readonly<Record<ImportAction, number>> {
  const counts: Record<ImportAction, number> = { create: 0, update: 0, unchanged: 0, blocked: 0 };
  for (const row of rows) counts[row.action] += 1;
  return counts;
}

export function error(column: string | null, message: string): ImportIssue {
  return { level: 'error', column, message };
}

export function warning(column: string | null, message: string): ImportIssue {
  return { level: 'warning', column, message };
}
